import React from 'react'
import {Button, StyleProps} from '@miro-site/core'
import {DefaultTheme} from 'styled-components'
import {ButtonOptions, ButtonTypes} from './types'

const BUTTON_TYPES: Record<ButtonTypes, keyof DefaultTheme['buttons']['variants']> = {
  transparent: 'transparent',
  'secondary-white': 'secondary',
  'secondary-dark': 'secondaryBlue',
  dark: 'dark',
  white: 'white',
  'transparent-white': 'transparentWhite',
  blue: 'primary',
}

type ButtonAdapterProps = ButtonOptions & {
  $styles?: StyleProps
}

const ButtonAdapter: React.FC<ButtonAdapterProps> = ({
  class: className = '',
  href = '#',
  text,
  arrow = true,
  type = 'blue',
  $styles = {},
  template_id,
}) => {
  return (
    <Button
      $styles={$styles}
      className={className}
      $withArrow={arrow}
      $buttonType={BUTTON_TYPES[type]}
      $size="medium"
      href={href}
      templateId={template_id}
    >
      {text}
    </Button>
  )
}

export default ButtonAdapter
